// Library Imports
import {
  faInstagram,
  faXTwitter,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
// Components
import { FooterLink } from "./dependents/FooterLink";
import { FooterSocialIcon } from "./dependents/FooterSocialIcon";
// Functions, Helpers, Utils, and Hooks
import { getLocalization } from "../../../helpers/localization";
import useDeviceLanguage from "../../../hooks/useDeviceLanguage";
// CSS
import "./footer.scss";
// Assets and Images
import logo from "../../../assets/images/logo/logo.webp";
import { Link } from "@tanstack/react-router";

const Footer = () => {
  const deviceLanguage = useDeviceLanguage();

  return (
    <footer className="footer">
      <div className="logo-and-social-row display-flex align-items-center">
        <div className="footer-logo-col">
          <Link to="/">
            <img src={logo} alt="Logo" className="footer-logo" />
          </Link>
        </div>

        <div className="social-col display-flex">
          <FooterSocialIcon
            icon={faInstagram}
            url="https://www.instagram.com/laestrellitasc/"
          />
          <FooterSocialIcon icon={faFacebook} url="https://www.facebook.com/people/La-Estrellita/61579559139714/" />
          <FooterSocialIcon
            icon={faXTwitter}
            url="https://x.com/laestrellita_sc"
          />
        </div>
      </div>
      <div className="footer-navigation display-flex justify-content-space-around">
        <div className="footer-navigation-column">
          <h5 className="footer-navigation-header bold-text full-flex">
            {getLocalization("footer", "contact", deviceLanguage)}
          </h5>

          <div className="footer-link-column display-flex">
            <FooterLink
              linkText={getLocalization(
                "footer",
                "phoneNumber",
                deviceLanguage
              )}
              url="tel:+19189342685"
              openInNewTab={false}
            />
            <FooterLink
              linkText={getLocalization("footer", "address", deviceLanguage)}
              url="maps://?q=6227+White+Horse+Rd,+Greenville,+SC+29611,+USA"
              openInNewTab={false}
            />
          </div>
        </div>
        <div className="footer-navigation-column">
          <h5 className="footer-navigation-header bold-text full-flex">
            {getLocalization("footer", "info", deviceLanguage)}
          </h5>

          <div className="footer-link-column display-flex">
            <FooterLink
              linkText={getLocalization("footer", "menu", deviceLanguage)}
              url="/menu"
              openInNewTab={false}
            />
            {/* <FooterLink linkText="Location" url="/faqs" openInNewTab={false} /> */}
          </div>
        </div>
        <div className="footer-navigation-column">
          <h5 className="footer-navigation-header bold-text full-flex">
            {getLocalization("footer", "other", deviceLanguage)}
          </h5>

          <div className="footer-link-column display-flex">
            <FooterLink
              linkText={getLocalization(
                "footer",
                "termsOfService",
                deviceLanguage
              )}
              url="/terms-of-service"
              openInNewTab={false}
            />
            <FooterLink
              linkText={getLocalization(
                "footer",
                "privacyPolicy",
                deviceLanguage
              )}
              url="/privacy-policy"
              openInNewTab={false}
            />
          </div>
        </div>
      </div>
      <div className="footer-copywrite-disclaimer-wrapper align-items-center display-flex justify-content-space-between">
        <div className="copywrite-container display-flex">
          <small className="copywrite-disclaimer padding-right-10">
            {getLocalization("footer", "copywrite", deviceLanguage)}
          </small>
          <a href="https://weblordshub.com/" target="_blank">
            <img
              src="https://weblordshub.com/assets/logo-5CMEOra5.png"
              alt="Weblords Hub"
              style={{ width: "50px" }}
            />
          </a>
        </div>

        {/*         <div className="footer-bottom-navigation-wrapper display-flex justify-content-right">
          <div>
            <FooterLink
              linkText="Terms of Service"
              url="/terms-of-service"
              openInNewTab={false}
            />
          </div>
          <div>
            <FooterLink
              linkText="Privacy Policy"
              url="/privacy-policy"
              openInNewTab={false}
            />
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
